import React from 'react';

import { colors } from '@/globalStyles';

const SaveIcon = props => {
  const { width = 30, height = 25, color = colors.white } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 30 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.4442 3.71246C22.4263 2.70063 21.0871 2.14282 19.654 2.14282H5.35714C2.40268 2.14282 0 4.54617 0 7.49996V26.7857C0 29.7388 2.40268 32.1428 5.35714 32.1428H24.6429C27.598 32.1428 30 29.7395 30 26.7857V12.4888C30 11.0571 29.4434 9.7118 28.4304 8.69996L23.4442 3.71246ZM6.42857 4.28568H19.2857V10.7143H6.42857V4.28568ZM27.8571 26.7857C27.8571 28.5582 26.4154 30 24.6429 30H5.35714C3.5846 30 2.14286 28.5602 2.14286 26.7857V7.49996C2.14286 6.1051 3.04152 4.92653 4.28571 4.48322V10.7143C4.28571 11.8975 5.24531 12.8571 6.42857 12.8571H19.2857C20.469 12.8571 21.4286 11.8975 21.4286 10.7143V4.82273C21.607 4.94046 21.7745 5.07526 21.9267 5.2274L26.9155 10.2162C27.5223 10.8214 27.8571 11.6317 27.8571 12.4888V26.7857ZM15 16.0714C12.0449 16.0714 9.64286 18.4747 9.64286 21.4285C9.64286 24.3823 12.0455 26.7857 15 26.7857C17.9545 26.7857 20.3571 24.3823 20.3571 21.4285C20.3571 18.4747 17.9531 16.0714 15 16.0714ZM15 24.6428C13.2275 24.6428 11.7857 23.2011 11.7857 21.4285C11.7857 19.656 13.2254 18.2143 15 18.2143C16.7746 18.2143 18.2143 19.656 18.2143 21.4285C18.2143 23.2011 16.7746 24.6428 15 24.6428Z"
        fill={color}
      />
    </svg>
  );
};

export default SaveIcon;
